import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { Translate } from "react-redux-i18n";
import WirelessPlan from "../Common/WirelessPlan";
import WirelessPlanMessage from "../Common/WirelessPlanMessage";
import KitProduct from "./KitProduct";
import { updateKitQuantity } from "../../Store/Catalog/Actions";
import { ProductLoader } from "../Loaders/Loaders";
import { goNext, onFinish, goPrev } from "../../Store/Wizard/Actions";
import { updateTempCart, updateTempCartKitUI } from "../../Store/Cart/Actions";

class KitItemsContainer extends Component {
    renderLoadingItems(count) {
        const items = [];

        for (let i = 0; i < count; i++) {
            const element =
                <div key={i} className="col-md-6">
                    {ProductLoader(i)}
                </div>
            ;

            items.push(element);
        }

        return items;
    }

    renderProducts() {
        const { items, showDetails, filter, addToCart, updateKitQuantity, qtyReadOnly, wizard, wizardName, tempCart, config: { DATA_PLANS_CATEGORY_ID, PANASONIC_DEVICE_IDS }, currentSelection, setCurrentId } = this.props;
        let selectedPlan = null;
        let valueIndex = null;

        if (tempCart && tempCart.Plan) {
            const plan = _.map(tempCart.Plan, v => v)[0];
            selectedPlan = plan.id;

            if (plan.productAttributes && plan.productAttributes.length > 0) {
                valueIndex = _.findIndex(plan.productAttributes[0].values, v => v.id === plan.attributeValueId);
            }
        }

        if (!items || items.length === 0) {
            return this.renderLoadingItems(2);
        } else {
            if (items[0].category.id === DATA_PLANS_CATEGORY_ID) {
                let itemArr = items;
                if (PANASONIC_DEVICE_IDS.includes(currentSelection)){
                    itemArr = itemArr.filter(x => x.name !== "T-Mobile Data Plans");
                }
                return _.map(itemArr, product =>
                    <WirelessPlan
                        key={product.id}
                        filter={filter}
                        image={product.defaultPictureModel.fullSizeImageUrl}
                        title={product.name}
                        price={product.productPrice.price}
                        product={product}
                        wizardName={wizardName}
                        wizard={wizard}
                        addToCart={addToCart}
                        updateQuantity={updateKitQuantity}
                        qtyReadOnly={qtyReadOnly}
                        showDetails={showDetails}
                        productAttributes={product.productAttributes}
                        selectedOption={parseInt(selectedPlan || -1) === parseInt(product.id) ? valueIndex : -1}
                        selectedPlanId={selectedPlan}
                    />
                );
            } else if (wizard) {
                return _.map(items, product =>
                    <KitProduct
                        key={product.id}
                        filter={filter}
                        image={product.defaultPictureModel.fullSizeImageUrl}
                        title={product.name}
                        price={product.productPrice.price}
                        // price={Utilities.getValueFromPriceString(product.productPrice.price)}
                        product={product}
                        wizardName={wizardName}
                        wizard={wizard}
                        addToCart={addToCart}
                        updateQuantity={updateKitQuantity}
                        qtyReadOnly={qtyReadOnly}
                        showDetails={showDetails}
                        productAttributes={product.productAttributes}
                        setCurrentId={setCurrentId}
                    />
                );
            }
        }
    }

    // message below the progress bar for each step
    renderMessage() {
        const { filter, items, config: { DATA_PLANS_CATEGORY_ID } } = this.props;

        if (filter === "Kit") {
            return (
                <h4><Translate value="buildAKit.wizard.steps.one.message" /></h4>
            )
        } else if (filter === "Plan" && items[0].category.id === DATA_PLANS_CATEGORY_ID) {
            var shortDescArray = items[0].shortDescription.split(" *");
            return (
                //  driven from the short description of the first item from the data plans
                <div className="highlighted-message">
                    {this.buildHighlightedMessage(shortDescArray)}
                </div>
            )
        } else {
            return null;
        }

    }

    buildHighlightedMessage(descArr) {
        var elements = _.map(descArr, (desc, index) => {
            if (index === 0) {
                return <div className="highlighted-message-body" key={index}>{desc}</div>
            } else {
                return <div className="highlighted-sub-container" key={index}><span className="highlighted-sub-message">*{desc}</span></div>
            }
            
        });
        return elements;
    }

    // nextOnClick() {
    //     // TODO this is in the next button listener
    //     const { wizards, goNext, onFinish } = this.props;
    //     const { totalSteps, currentStep } = wizards.KitsBuild;
    //
    //     // Wizard is finished at the second to last step because the last step is the Cart
    //     if (currentStep === totalSteps) {
    //         onFinish("KitsBuild");
    //     } else {
    //         goNext("KitsBuild");
    //     }
    //
    //     window.scrollTo(0, 0);
    // }

    previousOnClick() {
        const { goPrev } = this.props;
        goPrev("KitsBuild");
        window.scrollTo(0, 0);
    }

    render() {
        const { wizards, filter } = this.props;

        return (
            <div>
                <div className="build-kit-wizard-message">
                    <div className="row">
                        <div className="col-md-12">
                            {this.renderMessage()}
                        </div>
                    </div>
                </div>
                <div className="masonry">
                    <div className="masonry__container row masonry--active">
                        {this.renderProducts()}
                    </div>
                </div>
                {filter === "Plan" &&
                <div className="row build-kit-plan-row">
                    <div className="col-lg-9 col-xl-10">
                        <WirelessPlanMessage />
                    </div>
                    <div className="col-lg-3 col-xl-2">
                        <section className="actions clearfix kit-wireless-buttons">
                            <ul role="menu" aria-label="Pagination">
                                <li className="" aria-disabled="false">
                                    <button type="button" onClick={ () => this.previousOnClick()}><Translate value="misc.previous" /></button>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        config: state.config,
        wizards: state.wizards,
        tempCart: state.tempCart
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateKitQuantity: updateKitQuantity,
        goNext: goNext,
        goPrev: goPrev,
        onFinish: onFinish,
        updateTempCart: updateTempCart,
        updateTempCartKitUI: updateTempCartKitUI
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KitItemsContainer));
